import React from 'react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { getCapitalAccountSession } from '../../services/capital';
import useStripeOptions from '../stripe/useStripeOptions';
import { STRIPE_PK } from '../../constants/stripe';
import { userHasAccessToCapital } from '../../helpers/capital';
import useUser from '../global/useUser';

function useConnectCapital() {
  const { user } = useUser();
  const stripeOptions = useStripeOptions();

  const hasAccess = userHasAccessToCapital(user);

  const fetchClientSecret = React.useCallback(async () => {
    if (!user?.business || !hasAccess)
      throw new Error('User does not have access to capital');
    const session = await getCapitalAccountSession({
      businessId: user.business.id!,
    });
    return session.client_secret;
  }, [user?.business, hasAccess]);

  const connect = React.useMemo(
    () =>
      hasAccess
        ? loadConnectAndInitialize({
            publishableKey: STRIPE_PK!,
            fetchClientSecret,
            ...stripeOptions,
          })
        : null,
    [hasAccess, fetchClientSecret, stripeOptions],
  );

  return connect;
}

export default useConnectCapital;
